export enum RetailCrmSalutation {
  NONE = 'ANKEI',
  MR = 'ANHER',
  MRS = 'ANFRA',
  MX = 'ANMX',
  // GB/IE markets only
  DR = 'ANDR',
  MISS = 'ANMIS',
  MS = 'ANMS',
}
